export const selectCanteenState = (state) => state.canteen;

